export const B2U_REBRAND_CONTENT_TYPES = [
	"RebrandPage",
	"RebrandProgram",
	"RebrandBlogIndex",
	"RebrandBlog",
];

export const B2U_REBRAND_PHASED_ROLLOUT_VWO_COOKIE = "_vis_opt_exp_112_combi";
